// extracted by mini-css-extract-plugin
export default {"tableCell":"PacksControls_tableCell__DqjcK","image":"PacksControls_image__Wsflc","packName":"PacksControls_packName__dav08"};